
import { User } from "@supabase/supabase-js";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogIn, LogOut } from "lucide-react";

interface CoursePageHeaderProps {
  course: any;
  creator: any;
  moduleCount: number;
  lessonCount: number;
  totalDuration: number;
  additionalInfo?: any;
  onLogout?: () => Promise<void>;
  user?: User | null;
}

export function CoursePageHeader({
  course,
  creator,
  moduleCount,
  lessonCount, 
  totalDuration,
  additionalInfo,
  onLogout,
  user
}: CoursePageHeaderProps) {
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleLogin = () => {
    navigate("/student-auth", { 
      state: { from: location.pathname }
    });
  };
  
  return (
    <div className="container mx-auto px-4 -mt-16 relative z-10">
      <div className="bg-card rounded-lg shadow-lg p-6 border">
        <div className="flex flex-col md:flex-row justify-between gap-4">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold mb-2">{course.title}</h1>
            <p className="text-muted-foreground mb-4">Created by {creator.full_name || creator.username}</p>
            
            <div className="flex flex-wrap gap-4">
              <div className="text-sm">
                <span className="font-medium">{moduleCount}</span> {moduleCount === 1 ? 'module' : 'modules'}
              </div>
              <div className="text-sm">
                <span className="font-medium">{lessonCount}</span> {lessonCount === 1 ? 'lesson' : 'lessons'}
              </div>
              {totalDuration > 0 && (
                <div className="text-sm">
                  <span className="font-medium">
                    {Math.floor(totalDuration / 60) > 0 ? 
                      `${Math.floor(totalDuration / 60)}h ${totalDuration % 60}m` : 
                      `${totalDuration}m`}
                  </span> total length
                </div>
              )}
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            {user ? (
              <Button 
                variant="outline"
                size="sm"
                onClick={onLogout}
                className="flex items-center gap-2"
              >
                <LogOut className="h-4 w-4" />
                <span>Sign Out</span>
              </Button>
            ) : (
              <Button 
                variant="outline"
                size="sm"
                onClick={handleLogin}
                className="flex items-center gap-2"
              >
                <LogIn className="h-4 w-4" />
                <span>Student Login</span>
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
